define('modules/lp_integration/views/webservice_fields_step_itemview',['require','exports','module','base/itemview','ldsh!../templates/webservice_fields_step'],function(require, exports, module){
  "use strict";

  var ItemView = require("base/itemview");

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/webservice_fields_step"),
    className: "ed-section-group",
    helpers: function() {
      return {
        dataFields: this.parent.model.get("fields")
      };
    }
  });
});

